import { denormalize } from "normalizr";
import { offerPartnerContactModeSchema } from "features/common/schemas";
import { consts } from "constants/contactModeTypes";

export const getOfferPartnerContactModes = (state, partnerId) => {
  if (partnerId == null) {
    return { loading: false, loaded: false, content: null };
  }

  const flags = state.currentOffer.clientContactModesData[partnerId];
  if (!flags || !flags.loaded || flags.loading) return { loaded: false };

  const loaded = flags && flags.loaded;
  const loading = flags && flags.loading;
  const contactModeState = state.currentOffer.clientContactModesData[partnerId];
  const content = loaded ? denormalize(contactModeState.ids, [offerPartnerContactModeSchema], state.entities) : [];

  return { loading, loaded, content };
};

export const getEmail = (state, partnerId) => {
  if (partnerId == null) {
    return { loading: false, loaded: false, content: null };
  }

  const { content, loading, loaded } = getOfferPartnerContactModes(state, partnerId);
  const email = content?.find(
    contactMode => contactMode.isDefault === true && contactMode.contactModeId === consts.Email
  )?.contactInfo;

  return { loading, loaded, email };
};
